import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ManageLinkModalComponent } from 'src/app/components/modal/manage-link-modal/manage-link-modal.component';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { OperationHistoryModalComponent } from 'src/app/components/modal/operation-history-modal/operation-history-modal.component';
import { PublicSharingsModel } from 'src/app/models/share-links.model';
import { SharesService } from 'src/app/pages/shares/shares.service';
import { HumanizedDatePipe } from 'src/app/pipes/humanized-date.pipe';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-manage-links-modal',
  standalone: true,
  templateUrl: './manage-links-modal.component.html',
  styleUrls: ['./manage-links-modal.component.scss'],
  imports: [CommonModule, HumanizedDatePipe, ModalComponent, OperationHistoryModalComponent, ManageLinkModalComponent, TranslateModule],
})
export class ManageLinksModalComponent implements OnInit, OnDestroy {
  isModalOpened = false;
  isShares!: boolean;
  modalTitle = this.commonService.getTranslatedMessage('MANAGE_LINKS');
  modalId = 'manageLinks';
  removedItems: any[] = [];
  selectedItem: any = null;
  selectedListItem?: PublicSharingsModel;

  subscription: Subscription = new Subscription();
  itemSubscription: Subscription = new Subscription();
  successSubscription: Subscription = new Subscription();
  @ViewChild('closeRefmodal') closeRefmodal!: ElementRef;

  public items!: PublicSharingsModel[];
  subscriptions: Subscription[] = [];

  constructor(private sharesService: SharesService, private commonService: CommonService, private notificationService: NotificationService, private router: Router) {
    this.isShares = this.router.url.startsWith('/paylasimlar');
  }

  ngOnInit(): void {
    if (this.isShares) {
      this.commonService.sharesMultipleSelectedItems$.subscribe((selectedItems) => {
        this.selectedItem = undefined;
        if (selectedItems && selectedItems.length === 1) {
          [this.selectedItem] = selectedItems;
        }
      });
    } else {
      this.commonService.multipleSelectedItems$.subscribe((selectedItems) => {
        this.selectedItem = undefined;
        if (selectedItems.length === 1) {
          [this.selectedItem] = selectedItems;
        }
      });
    }

    this.itemSubscription = this.commonService.selectedRowItem.subscribe((item) => {
      this.unsubscribePreviousSubscriptions();
      this.successSubscription = this.commonService.manageLinkSuccessResponse.subscribe(() => {
        this.subscription = this.sharesService.getPublicSharings(item.objectId).subscribe({
          next: (data) => {
            this.items = data.content;
          },
        });
      });
      this.subscriptions.push(this.successSubscription);
    });
  }

  unsubscribePreviousSubscriptions(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.itemSubscription) this.itemSubscription.unsubscribe();
    if (this.successSubscription) this.successSubscription.unsubscribe();
  }

  selectItem(item: any): void {
    this.commonService.sendListInfoToManageLink.next(item);
  }

  removeItem(item: any): void {
    this.subscription = this.sharesService.cancelShares([], [item.publicShareId]).subscribe({
      next: () => {
        this.commonService.cancelCreatedLink.next(true);
      },
      complete: () => {
        this.removedItems.push(item);
        this.items = this.items.filter((i) => i.publicShareId !== item.publicShareId);
        if (this.items && this.items.length === 0) {
          if (this.closeRefmodal && this.closeRefmodal.nativeElement) {
            this.closeRefmodal.nativeElement.click();
          }
        }
        this.commonService.rebindListener.next();
      },
    });
  }

  onCopyShareLink(item: any): void {
    const copyTextArea = document.createElement('textarea');
    copyTextArea.value = window.location.origin + '/baglanti-paylasimi/' + item.shareId;
    document.body.appendChild(copyTextArea);
    copyTextArea.select();
    this.copyToClipboard(copyTextArea.value);
    copyTextArea.remove();
    const notification = {
      message: this.commonService.getTranslatedMessage('LINK_COPIED'),
    };
    this.notificationService.successNotification(notification);
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text);
  }
}
